/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppContentIndexRouteImport } from './routes/app/content/index'
import { Route as AppCommentsIndexRouteImport } from './routes/app/comments/index'
import { Route as AppBrandsIndexRouteImport } from './routes/app/brands/index'
import { Route as AppPostsPostIdRouteImport } from './routes/app/posts/$postId'
import { Route as AppGenerationsGenerationIdRouteImport } from './routes/app/generations/$generationId'
import { Route as AppContentNewRouteImport } from './routes/app/content/new'
import { Route as AppContentBulkRouteImport } from './routes/app/content/bulk'
import { Route as AppContentBrandIdRouteImport } from './routes/app/content/$brandId'
import { Route as AppBulkJobsBulkJobIdRouteImport } from './routes/app/bulk-jobs/$bulkJobId'
import { Route as AppBrandsNewRouteImport } from './routes/app/brands/new'
import { Route as AppBrandsBrandIdRouteImport } from './routes/app/brands/$brandId'
import { Route as AppAdminHealthRouteImport } from './routes/app/admin/health'
import { Route as AppBrandsBrandIdIntegrationsRouteImport } from './routes/app/brands/$brandId_.integrations'
import { Route as AppBrandsBrandIdGalleryRouteImport } from './routes/app/brands/$brandId_.gallery'
import { Route as AppBrandsBrandIdCommentsRouteImport } from './routes/app/brands/$brandId_.comments'
import { Route as AppBrandsBrandIdCalendarRouteImport } from './routes/app/brands/$brandId_.calendar'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContentIndexRoute = AppContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCommentsIndexRoute = AppCommentsIndexRouteImport.update({
  id: '/comments/',
  path: '/comments/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsIndexRoute = AppBrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPostsPostIdRoute = AppPostsPostIdRouteImport.update({
  id: '/posts/$postId',
  path: '/posts/$postId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGenerationsGenerationIdRoute =
  AppGenerationsGenerationIdRouteImport.update({
    id: '/generations/$generationId',
    path: '/generations/$generationId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppContentNewRoute = AppContentNewRouteImport.update({
  id: '/content/new',
  path: '/content/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContentBulkRoute = AppContentBulkRouteImport.update({
  id: '/content/bulk',
  path: '/content/bulk',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContentBrandIdRoute = AppContentBrandIdRouteImport.update({
  id: '/content/$brandId',
  path: '/content/$brandId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBulkJobsBulkJobIdRoute = AppBulkJobsBulkJobIdRouteImport.update({
  id: '/bulk-jobs/$bulkJobId',
  path: '/bulk-jobs/$bulkJobId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsNewRoute = AppBrandsNewRouteImport.update({
  id: '/brands/new',
  path: '/brands/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsBrandIdRoute = AppBrandsBrandIdRouteImport.update({
  id: '/brands/$brandId',
  path: '/brands/$brandId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminHealthRoute = AppAdminHealthRouteImport.update({
  id: '/admin/health',
  path: '/admin/health',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsBrandIdIntegrationsRoute =
  AppBrandsBrandIdIntegrationsRouteImport.update({
    id: '/brands/$brandId_/integrations',
    path: '/brands/$brandId/integrations',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppBrandsBrandIdGalleryRoute = AppBrandsBrandIdGalleryRouteImport.update({
  id: '/brands/$brandId_/gallery',
  path: '/brands/$brandId/gallery',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBrandsBrandIdCommentsRoute =
  AppBrandsBrandIdCommentsRouteImport.update({
    id: '/brands/$brandId_/comments',
    path: '/brands/$brandId/comments',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppBrandsBrandIdCalendarRoute =
  AppBrandsBrandIdCalendarRouteImport.update({
    id: '/brands/$brandId_/calendar',
    path: '/brands/$brandId/calendar',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/health': typeof AppAdminHealthRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRoute
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/bulk-jobs/$bulkJobId': typeof AppBulkJobsBulkJobIdRoute
  '/app/content/$brandId': typeof AppContentBrandIdRoute
  '/app/content/bulk': typeof AppContentBulkRoute
  '/app/content/new': typeof AppContentNewRoute
  '/app/generations/$generationId': typeof AppGenerationsGenerationIdRoute
  '/app/posts/$postId': typeof AppPostsPostIdRoute
  '/app/brands/': typeof AppBrandsIndexRoute
  '/app/comments/': typeof AppCommentsIndexRoute
  '/app/content/': typeof AppContentIndexRoute
  '/app/brands/$brandId/calendar': typeof AppBrandsBrandIdCalendarRoute
  '/app/brands/$brandId/comments': typeof AppBrandsBrandIdCommentsRoute
  '/app/brands/$brandId/gallery': typeof AppBrandsBrandIdGalleryRoute
  '/app/brands/$brandId/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/settings': typeof AppSettingsRoute
  '/app': typeof AppIndexRoute
  '/app/admin/health': typeof AppAdminHealthRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRoute
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/bulk-jobs/$bulkJobId': typeof AppBulkJobsBulkJobIdRoute
  '/app/content/$brandId': typeof AppContentBrandIdRoute
  '/app/content/bulk': typeof AppContentBulkRoute
  '/app/content/new': typeof AppContentNewRoute
  '/app/generations/$generationId': typeof AppGenerationsGenerationIdRoute
  '/app/posts/$postId': typeof AppPostsPostIdRoute
  '/app/brands': typeof AppBrandsIndexRoute
  '/app/comments': typeof AppCommentsIndexRoute
  '/app/content': typeof AppContentIndexRoute
  '/app/brands/$brandId/calendar': typeof AppBrandsBrandIdCalendarRoute
  '/app/brands/$brandId/comments': typeof AppBrandsBrandIdCommentsRoute
  '/app/brands/$brandId/gallery': typeof AppBrandsBrandIdGalleryRoute
  '/app/brands/$brandId/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/health': typeof AppAdminHealthRoute
  '/app/brands/$brandId': typeof AppBrandsBrandIdRoute
  '/app/brands/new': typeof AppBrandsNewRoute
  '/app/bulk-jobs/$bulkJobId': typeof AppBulkJobsBulkJobIdRoute
  '/app/content/$brandId': typeof AppContentBrandIdRoute
  '/app/content/bulk': typeof AppContentBulkRoute
  '/app/content/new': typeof AppContentNewRoute
  '/app/generations/$generationId': typeof AppGenerationsGenerationIdRoute
  '/app/posts/$postId': typeof AppPostsPostIdRoute
  '/app/brands/': typeof AppBrandsIndexRoute
  '/app/comments/': typeof AppCommentsIndexRoute
  '/app/content/': typeof AppContentIndexRoute
  '/app/brands/$brandId_/calendar': typeof AppBrandsBrandIdCalendarRoute
  '/app/brands/$brandId_/comments': typeof AppBrandsBrandIdCommentsRoute
  '/app/brands/$brandId_/gallery': typeof AppBrandsBrandIdGalleryRoute
  '/app/brands/$brandId_/integrations': typeof AppBrandsBrandIdIntegrationsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/app/settings'
    | '/app/'
    | '/app/admin/health'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/bulk-jobs/$bulkJobId'
    | '/app/content/$brandId'
    | '/app/content/bulk'
    | '/app/content/new'
    | '/app/generations/$generationId'
    | '/app/posts/$postId'
    | '/app/brands/'
    | '/app/comments/'
    | '/app/content/'
    | '/app/brands/$brandId/calendar'
    | '/app/brands/$brandId/comments'
    | '/app/brands/$brandId/gallery'
    | '/app/brands/$brandId/integrations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/app/settings'
    | '/app'
    | '/app/admin/health'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/bulk-jobs/$bulkJobId'
    | '/app/content/$brandId'
    | '/app/content/bulk'
    | '/app/content/new'
    | '/app/generations/$generationId'
    | '/app/posts/$postId'
    | '/app/brands'
    | '/app/comments'
    | '/app/content'
    | '/app/brands/$brandId/calendar'
    | '/app/brands/$brandId/comments'
    | '/app/brands/$brandId/gallery'
    | '/app/brands/$brandId/integrations'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/app/settings'
    | '/app/'
    | '/app/admin/health'
    | '/app/brands/$brandId'
    | '/app/brands/new'
    | '/app/bulk-jobs/$bulkJobId'
    | '/app/content/$brandId'
    | '/app/content/bulk'
    | '/app/content/new'
    | '/app/generations/$generationId'
    | '/app/posts/$postId'
    | '/app/brands/'
    | '/app/comments/'
    | '/app/content/'
    | '/app/brands/$brandId_/calendar'
    | '/app/brands/$brandId_/comments'
    | '/app/brands/$brandId_/gallery'
    | '/app/brands/$brandId_/integrations'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/content/': {
      id: '/app/content/'
      path: '/content'
      fullPath: '/app/content/'
      preLoaderRoute: typeof AppContentIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/comments/': {
      id: '/app/comments/'
      path: '/comments'
      fullPath: '/app/comments/'
      preLoaderRoute: typeof AppCommentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/': {
      id: '/app/brands/'
      path: '/brands'
      fullPath: '/app/brands/'
      preLoaderRoute: typeof AppBrandsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/posts/$postId': {
      id: '/app/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/app/posts/$postId'
      preLoaderRoute: typeof AppPostsPostIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/generations/$generationId': {
      id: '/app/generations/$generationId'
      path: '/generations/$generationId'
      fullPath: '/app/generations/$generationId'
      preLoaderRoute: typeof AppGenerationsGenerationIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/content/new': {
      id: '/app/content/new'
      path: '/content/new'
      fullPath: '/app/content/new'
      preLoaderRoute: typeof AppContentNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/content/bulk': {
      id: '/app/content/bulk'
      path: '/content/bulk'
      fullPath: '/app/content/bulk'
      preLoaderRoute: typeof AppContentBulkRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/content/$brandId': {
      id: '/app/content/$brandId'
      path: '/content/$brandId'
      fullPath: '/app/content/$brandId'
      preLoaderRoute: typeof AppContentBrandIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/bulk-jobs/$bulkJobId': {
      id: '/app/bulk-jobs/$bulkJobId'
      path: '/bulk-jobs/$bulkJobId'
      fullPath: '/app/bulk-jobs/$bulkJobId'
      preLoaderRoute: typeof AppBulkJobsBulkJobIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/new': {
      id: '/app/brands/new'
      path: '/brands/new'
      fullPath: '/app/brands/new'
      preLoaderRoute: typeof AppBrandsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId': {
      id: '/app/brands/$brandId'
      path: '/brands/$brandId'
      fullPath: '/app/brands/$brandId'
      preLoaderRoute: typeof AppBrandsBrandIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/admin/health': {
      id: '/app/admin/health'
      path: '/admin/health'
      fullPath: '/app/admin/health'
      preLoaderRoute: typeof AppAdminHealthRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId_/integrations': {
      id: '/app/brands/$brandId_/integrations'
      path: '/brands/$brandId/integrations'
      fullPath: '/app/brands/$brandId/integrations'
      preLoaderRoute: typeof AppBrandsBrandIdIntegrationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId_/gallery': {
      id: '/app/brands/$brandId_/gallery'
      path: '/brands/$brandId/gallery'
      fullPath: '/app/brands/$brandId/gallery'
      preLoaderRoute: typeof AppBrandsBrandIdGalleryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId_/comments': {
      id: '/app/brands/$brandId_/comments'
      path: '/brands/$brandId/comments'
      fullPath: '/app/brands/$brandId/comments'
      preLoaderRoute: typeof AppBrandsBrandIdCommentsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/brands/$brandId_/calendar': {
      id: '/app/brands/$brandId_/calendar'
      path: '/brands/$brandId/calendar'
      fullPath: '/app/brands/$brandId/calendar'
      preLoaderRoute: typeof AppBrandsBrandIdCalendarRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminHealthRoute: typeof AppAdminHealthRoute
  AppBrandsBrandIdRoute: typeof AppBrandsBrandIdRoute
  AppBrandsNewRoute: typeof AppBrandsNewRoute
  AppBulkJobsBulkJobIdRoute: typeof AppBulkJobsBulkJobIdRoute
  AppContentBrandIdRoute: typeof AppContentBrandIdRoute
  AppContentBulkRoute: typeof AppContentBulkRoute
  AppContentNewRoute: typeof AppContentNewRoute
  AppGenerationsGenerationIdRoute: typeof AppGenerationsGenerationIdRoute
  AppPostsPostIdRoute: typeof AppPostsPostIdRoute
  AppBrandsIndexRoute: typeof AppBrandsIndexRoute
  AppCommentsIndexRoute: typeof AppCommentsIndexRoute
  AppContentIndexRoute: typeof AppContentIndexRoute
  AppBrandsBrandIdCalendarRoute: typeof AppBrandsBrandIdCalendarRoute
  AppBrandsBrandIdCommentsRoute: typeof AppBrandsBrandIdCommentsRoute
  AppBrandsBrandIdGalleryRoute: typeof AppBrandsBrandIdGalleryRoute
  AppBrandsBrandIdIntegrationsRoute: typeof AppBrandsBrandIdIntegrationsRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminHealthRoute: AppAdminHealthRoute,
  AppBrandsBrandIdRoute: AppBrandsBrandIdRoute,
  AppBrandsNewRoute: AppBrandsNewRoute,
  AppBulkJobsBulkJobIdRoute: AppBulkJobsBulkJobIdRoute,
  AppContentBrandIdRoute: AppContentBrandIdRoute,
  AppContentBulkRoute: AppContentBulkRoute,
  AppContentNewRoute: AppContentNewRoute,
  AppGenerationsGenerationIdRoute: AppGenerationsGenerationIdRoute,
  AppPostsPostIdRoute: AppPostsPostIdRoute,
  AppBrandsIndexRoute: AppBrandsIndexRoute,
  AppCommentsIndexRoute: AppCommentsIndexRoute,
  AppContentIndexRoute: AppContentIndexRoute,
  AppBrandsBrandIdCalendarRoute: AppBrandsBrandIdCalendarRoute,
  AppBrandsBrandIdCommentsRoute: AppBrandsBrandIdCommentsRoute,
  AppBrandsBrandIdGalleryRoute: AppBrandsBrandIdGalleryRoute,
  AppBrandsBrandIdIntegrationsRoute: AppBrandsBrandIdIntegrationsRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
